import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert } from "react-bootstrap";

const SaleBanner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const showBanner = ["/", "/store-front", "/store", "/napco-store"].includes(
    location.pathname,
  );

  if (!showBanner) return null;

  const handleNavigateToStore = () => {
    navigate("/store-front");
  };

  return (
    <Alert
      variant="danger"
      className="sale-banner"
      style={{
        backgroundColor: "#d80607",
        color: "#F8F9FA",
        textAlign: "center",
        cursor: "pointer",
        overflow: "hidden",
        padding: "0.5rem",
      }}
      onClick={handleNavigateToStore}
    >
      {/* <strong>Memorial Day Sale!</strong> Use Code '<strong>VETERAN</strong>' for{" "}
      <strong>30% Off</strong> New NAPCO Parts & <strong>30% Off</strong> New
      Aftermarket Parts */}
      {/* <strong>Memorial Weekend Sale!</strong> Use Code '<strong>VETERAN</strong>
      ' for <strong>30% Off</strong> New NAPCO Parts & New Aftermarket Parts! */}
      {/* <strong>SALE: </strong> <strong>10% Off</strong> Aftermarket & NAPCO
      Parts, <strong>25% Off</strong> Merch. Use Code '<strong>TURKEY</strong>'
      at checkout. Ends 11/30/25. */}
      <strong>Black Friday SALE: </strong> <strong>10% Off</strong> all
      Aftermarket & NAPCO Parts all month. Use Code '<strong>TURKEY</strong>' at
      checkout. Ends Nov 30 at 12am.
    </Alert>
  );
};

export default SaleBanner;
